import React from "react";
import Routes from "./Routes/index";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Esto es temporal, despues se ajusta a un contexto menos global
import AppBlocker from "./utils/AppBlocker";

//import Custom Style scss
import "./assets/scss/themes.scss";
function App() {
  return (
    
    <React.Fragment>
      <AppBlocker />
      <Routes />
      <ToastContainer />
    </React.Fragment>
    
  );
}

export default App;
